import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../common/Checkbox";
import Style from "style-it";
import SearchField from "../common/SearchField";
import Scrollbar from "react-scrollbars-custom";
import instance from "../../axios";
import isEqual from "react-fast-compare";

class CitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: {},
      search: "",
      isChecked: false,
      cities: { data: [], total: 0 },
      isLoading: false,
    };
  }

  componentDidMount() {
    this.initSelected();
    this.getCities();
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.search !== this.state.search) {
      this.getCities();
    }


    if (!isEqual(prevProps.value, this.props.value)) {
      this.initSelected();
    }
  }

  componentWillUnmount() {
    this.setState({
      list: {},
      search: "",
      isChecked: false,
      cities: { data: [], total: 0 },
    });
  }


  initSelected = () => {
    const selectedIds = this.props.value || [];
    const list = {};

    selectedIds.forEach((id) => {
      list[id] = true;
    });

    this.setState({
      list,
      isChecked:
        this.state.cities?.data?.length &&
        this.state.cities.data.length === selectedIds.length,
    });
  };

  getCities = () => {
    const userId = this.props.userId || this.props.logInUser?.id;
    if (!userId) return;

    const url = `api/citys/get?limit=-1&search=${this.state.search}`;

    this.setState({ isLoading: true });

    instance
      .get(url)
      .then((res) => {
        const response = res || res;

        this.setState(
          {
            cities: response,
            isLoading: false,
          },
          () => {
            const total = response?.data?.length || 0;
            const selected = Object.keys(this.state.list).length;

            this.setState({
              isChecked: total > 0 && total === selected,
            });
          }
        );
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };


  onChange = (e, city) => {
    let list = { ...this.state.list };

    if (e.target.checked) {
      list[city.id] = true;
    } else {
      delete list[city.id];
    }

    this.setState(
      {
        list,
        isChecked:
          this.state.cities?.data?.length === Object.keys(list).length,
      },
      () => {
        this.props.onChange &&
          this.props.onChange(Object.keys(this.state.list), "city");
      }
    );
  };


  toggleItems = (e) => {
    if (e.target.checked) {
      const list = {};
      this.state.cities?.data?.forEach((c) => {
        list[c.id] = true;
      });

      this.setState(
        { list, isChecked: true },
        () =>
          this.props.onChange &&
          this.props.onChange(Object.keys(list), "city")
      );
    } else {
      this.setState(
        { list: {}, isChecked: false },
        () =>
          this.props.onChange &&
          this.props.onChange([], "city")
      );
    }
  };

  searchItem = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    return (
      <Style>
        {`
          .selector-list li {
              margin-bottom: 6px;
          }
          .selector-list li > label {
              cursor: pointer;
              display: flex;
              align-items: center;
              padding: 2px 6px;
              border-radius: 4px;
          }
          .selector-list {
              padding: 0;
              margin: 0;
              list-style: none;
          }
          .selector-label {
              font-size: 12px;
              margin-left: 6px;
          }
          .selector-check {
              height: 26px;
              display: inline-flex;
              align-items: center;
          }
          .selector-count {
              padding: 5px 0;
              font-size: 12px;
          }
        `}
        <div>
  
          <div
            style={{
              marginBottom: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ flex: 0.65, marginRight: 10 }}>
              <SearchField
                label="Search Cities"
                type="search"
                placeholder="Search by name"
                value={this.state.search}
                onChange={this.searchItem}
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </div>
            <div style={{ flex: 0.35 }}>
              <Checkbox
                checked={this.state.isChecked}
                onChange={this.toggleItems}
                label="Select All"
              />
            </div>
          </div>


          <div className="selector-count">
            {Object.keys(this.state.list).length} Cities Selected
          </div>


          <Scrollbar style={{ height: 35 * (this.props.rows || 8) }}>
            {this.state.isLoading ? (
              <h3>Loading...</h3>
            ) : this.state.cities?.data?.length ? (
              <ul className="selector-list">
                {this.state.cities.data.map((row) => (
                  <li key={row.id}>
                    <label className={this.state.list[row.id] ? "active" : ""}>
                      <span className="selector-check">
                        <Checkbox
                          checked={this.state.list[row.id] || false}
                          onChange={(e) => this.onChange(e, row)}
                        />
                      </span>
                      <span className="selector-label">{row.cityEn}</span>
                    </label>
                  </li>
                ))}
              </ul>
            ) : (
              <div>No Cities Found</div>
            )}
          </Scrollbar>
        </div>
      </Style>
    );
  }
}

const mapState = (state) => ({
  logInUser: state.logInUsers,
});

export default connect(mapState)(CitySelector);